import { FC } from 'react';
import { Flex, HStack, HTMLChakraProps, Image } from '@chakra-ui/react';

import Text from 'components/_core/Text';

export interface MultipleCardPanelItem {
  color: string;
  img: string;
  name: string;
  title: string;
}

interface MultipleCardPanelProps
  extends Omit<HTMLChakraProps<'div'>, 'alignItems'> {
  items: MultipleCardPanelItem[];
}

const MultipleCardPanel: FC<MultipleCardPanelProps> = ({ items, ...props }) => {
  return (
    <HStack alignItems="stretch" {...props} spacing="space-16">
      {items.map((item: MultipleCardPanelItem) => (
        <Flex
          alignItems="center"
          backgroundColor={item.color}
          backgroundSize="cover"
          borderRadius="radius-8"
          flexDirection="column"
          key={item.name}
          padding="space-16"
          width="100%"
        >
          <Image alt="" boxSize="90px" src={item.img} />

          <Text
            color="primary"
            fontWeight="weight-500"
            marginTop="space-12"
            textAlign="center"
          >
            {item.title}
          </Text>
        </Flex>
      ))}
    </HStack>
  );
};

export default MultipleCardPanel;
